var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentIconImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49526",
    "data-name": "Group 49526",
    transform: "translate(-0.789 -0.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49525",
    "data-name": "Group 49525",
    transform: "translate(1.765 1.765)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138185",
    "data-name": "Rectangle 138185",
    width: 20,
    height: 20,
    rx: 4,
    transform: "translate(-0.226 -0.226)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93339",
    "data-name": "Path 93339",
    d: "M2,28H5.828A2.614,2.614,0,0,1,8,29.164l.191.286a2.614,2.614,0,0,0,2.174,1.164H12.8a2.614,2.614,0,0,0,2.174-1.164l.191-.286A2.614,2.614,0,0,1,17.337,28h3.828",
    transform: "translate(-1.809 -16.484)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_388",
    "data-name": "Line 388",
    x2: 4,
    transform: "translate(7.774 3.774)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_389",
    "data-name": "Line 389",
    x2: 4,
    transform: "translate(7.774 7.774)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIconImg);
export default __webpack_public_path__ + "static/media/assessment-icon-img.fed4a50d0105e63a6a5821658bc59b9d.svg";
export { ForwardRef as ReactComponent };